import { Check } from "@untitledui/icons";
import { cx } from "@/utils/cx";

type StepStatus = "incomplete" | "current" | "complete";

type Step = {
  title: string;
  status: StepStatus;
};

type Props = {
  steps: Step[];
  variant?: "brand" | "status";
};

export function ModalStepper({ steps, variant = "brand" }: Props) {
  return (
    <div className="flex w-full flex-row items-center justify-center gap-3">
      {steps.map((step, i) => {
        const isLast = i === steps.length - 1;
        const connectorBrand = variant === "brand" && step.status === "complete";

        return (
          <div key={step.title} className="flex flex-1 flex-col items-center justify-center gap-3">
            <div className="relative flex w-full flex-col items-center self-stretch">
              <span
                className={cx(
                  "z-10 flex size-8 shrink-0 items-center justify-center rounded-full text-sm font-semibold",
                  step.status === "incomplete" &&
                    "bg-primary ring-1 ring-inset ring-secondary text-disabled opacity-60",
                  variant === "brand" && step.status !== "incomplete" && "bg-brand-solid text-fg-white",
                  variant === "brand" && step.status === "current" && "ring-4 ring-[#EEF2FF]",
                  variant === "status" && step.status === "current" && "bg-primary-solid text-fg-white",
                  variant === "status" && step.status === "complete" && "bg-success-solid text-fg-white",
                )}
              >
                {variant === "status" && step.status === "complete" ? (
                  <Check className="size-4" />
                ) : (
                  <span className="leading-none">{i + 1}</span>
                )}
              </span>

              {!isLast && (
                <svg
                  className="absolute top-1/2 left-[calc(50%+31px)] z-0 h-[2.5px] w-[calc(100%-50px)] -translate-y-1/2"
                  aria-hidden="true"
                >
                  <line
                    x1="0"
                    y1="1.2"
                    x2="100%"
                    y2="1.2"
                    strokeWidth="2.4"
                    strokeDasharray="0,6"
                    strokeLinecap="round"
                    stroke={connectorBrand ? "rgb(127 86 217)" : "rgb(208 213 221)"}
                  />
                </svg>
              )}
            </div>

            <p
              className={cx(
                "w-full text-center text-sm",
                step.status === "current" && "font-semibold text-secondary",
                step.status === "complete" && "font-medium text-[#535862]",
                step.status === "incomplete" && "font-medium text-[#535862] opacity-60",
              )}
            >
              {step.title}
            </p>
          </div>
        );
      })}
    </div>
  );
}
